import { render, staticRenderFns } from "./NavUserCenterAvatar.vue?vue&type=template&id=7106b610&scoped=true&"
import script from "./NavUserCenterAvatar.vue?vue&type=script&lang=js&"
export * from "./NavUserCenterAvatar.vue?vue&type=script&lang=js&"
import style0 from "./NavUserCenterAvatar.vue?vue&type=style&index=0&id=7106b610&lang=less&scoped=true&"
import style1 from "./NavUserCenterAvatar.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7106b610",
  null
  
)

export default component.exports